import React from "react";
import BaseDialog from "../BaseDialog/BaseDialog";

export default function MessageDialog(props) {
  const { visible, title, message, onClose, onPositive, onNegative } = props;
  return (
    <BaseDialog
      visible={visible}
      title={title}
      message={message}
      onClose={onClose}
    />
  );
}
